import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { UrlSecurityService } from './url-security.service';
import { msalConfig } from '../../core/guards/msal-config';
import * as constant from '../constants/constants'
import { Sort } from '@angular/material/sort';
import { TableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { sortArrayOfObjects } from '../directives/sortArrayOfObjects';
import * as _moment from 'moment';
import { StorageService } from './storage.service';
import { action_items, currency_symbol_enum, localStorageKeys } from 'src/app/core/enum';
import { MsalService } from '@azure/msal-angular';

const moment = _moment;

type SortDirection = "ascending" | "descending" | "none";
@Injectable({
  providedIn: 'root'
})
export class UtilService {
  marketArray: any;
  constructor(private translateService: TranslateService, private urlService: UrlSecurityService, private storageService: StorageService, private msalService: MsalService) { }

  notification_visible = new Subject();
  market_trigger = new BehaviorSubject(false);
  role_id_trigger = new BehaviorSubject(null);
  navigation_trigger = new BehaviorSubject(false);
  key_trigger = new BehaviorSubject(false)
  navigation_codes:any = [];
  features_available:any = []

  /**
  * param translated value
  * Do the translation based on the selected language.
  */
  languageTranslator(key: any, topicName?: any): string {
    let translatedvalue: any;
    this.translateService.get(key, { value: topicName }).subscribe(value => {
      translatedvalue = value;
    });
    return translatedvalue;
  }

  async setMarketValue(){
    await this.market_trigger.next(await this.storageService.get(localStorageKeys.market))
    await this.navigation_trigger.next(await this.storageService.get(localStorageKeys.menu))
  }

  /**
   * param string a string
   * return true if the string is not null, not undefined and has non-whitespace length at least one, else false
   */
  isNullOrEmptyOrUndefined(data: any): boolean {
    return data == null || data == undefined || data === '';
  }

    /**
   * param string a string
   * return true if the string is not null, not undefined, has empty array and has non-whitespace length at least one, else false
   */
  isNullOrEmptyOrUndefinedOrEmptyArray(data: any): boolean {
    return data == null || data == undefined || data === '' || (Array.isArray(data) && data.length === 0);
  }

  /**
   * param key and value
   * set the values in the session storage
   */
  setValuesToSessionStorage(key: any, value: any) {
    let setValue: any;
    setValue = sessionStorage.setItem(key, this.urlService.encryptUsingAES256(JSON.stringify(value)));
    return setValue;
  }

  /**
   * param key
   * get the values from the session storage
   */
  getValuesFromSessionStorage(key: any) {
    return JSON.parse(this.urlService.decryptUsingAES256(sessionStorage.getItem((key))));
  }

  // isNavBarOpen(){
  //   return this.sideBar.getValue()
  // }

  // sideBar = new BehaviorSubject<boolean>(false);

  loginPage = new BehaviorSubject<boolean>(false);

  /**
 *
 * @param newPrice
 * @returns rechange into as valid number
 */
  validateNumberCheck(newPrice: any) {
    let removeComma = newPrice?.toString().replace(",", ".")
    return Number(removeComma?.replace(/[^0-9.-]+/g, ""))
  }

  /**
 *
 * @returns getting the token from the session storage
 */

  getTokenFromSession() {
    let accessTokenKey = JSON.parse(localStorage.getItem(constant.common.msalTokenKeys + '.' + msalConfig.auth.clientId) || '{}')
    if(Object.keys(accessTokenKey).length > 0) {
      let accessToken = JSON.parse(localStorage.getItem(accessTokenKey?.accessToken[0]) || '{}');
      return accessToken;
    }else {
      return null;
    }
    
  }

    /**
 * 
 * virutal scroll view port calulation .. Return dynamic virutal scroll table height in the from of px
 * @param count 
 * @returns 
 */
  viewPortCalcuation(count: number) {
    return (count * constant.common.itemSize) + constant.common.bufferRange  >= constant.common.totalViewPortRange ? 
    constant.common.totalViewPortRange : (count * constant.common.itemSize) + constant.common.bufferRange;
  }

  /**
   * param date
   * get the values from the session storage
   */
  getStartDate(end_date: any, default_range:any) {
    return new Date(new Date().setDate(end_date.getDate() - default_range))
  }

  getEndDate(start_date: any, default_range:any) {
    return new Date(new Date().setDate(start_date.getDate() + default_range))
  }
  
 /**
   * param date
   * get the values from the session storage
   */
  formatDate(date: any) {
    if (date) {
      const day = ('0' + date.getDate()).slice(-2);
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    }
    return undefined;
  }

    /**
 * 
 * @param value 
 * @returns 
 * If it's a negative number, it will be converted to a positive number, 
  * fixed with 2, and surrounded by a bracket.
  * If it's a positive number, it will be fixed with 2.
  * it's null or empty, it will return "-."
 */
    priceMetricCalculationWithDecimalService(value: any,decimal_points:any) {
    if (!this.isNullOrEmptyOrUndefined(value)) {
      if (value < 0) {
        return this.negativeNumberValidation(value,decimal_points)
      } else {
        let tem = parseFloat(value).toFixed(decimal_points)
        return tem;
      }
    } else {
      return "-"
    }
  }

  priceMetricCalculationWithThousandsService(value: any,decimal_points:any) {
    if (!this.isNullOrEmptyOrUndefined(value)) {
      if(Number.isNaN(Number(value))) value = value.replace(/,/g, '');
      if (value >= 1000000) {
        return (value / 1000000).toFixed(decimal_points) + 'M'; // Convert to millions
      } else if (value >= 1000) {
        return (value / 1000).toFixed(decimal_points) + 'k'; // Convert to thousands
      } else if (value < 0) {
        let temp: any = value;
        let thousand_flag: boolean = false;
        let million_flag: boolean = false;
        if(value <= -1000000){
          temp = value/1000000;
          million_flag = true;
        } else if(value <= -1000){
          temp = value/1000;
          thousand_flag = true;
        }
        temp = million_flag ? this.negativeNumberValidation(temp,decimal_points)+'M' : thousand_flag ? this.negativeNumberValidation(temp,decimal_points)+'k' : this.negativeNumberValidation(temp,decimal_points);
        return temp;
      } else {
        return value.toString(); // Return the original number if it's less than 1000
      }
    } else {
      return "-"
    }
  }

  /** Negative Number validation. Dynamically add bracket if valid negative number */
  negativeNumberValidation(value: any, decimal_points: any) {
    let num: any = Math.abs(value);
    num = parseFloat(num).toFixed(decimal_points);
    if (Number(num) == 0) {
      return num;
    }
    num = "(" + num + ")";
    return num;
  }

    /**
   * 
   * @param current_price 
   * @param scenario_price 
   * @param decimal_points 
   * @returns 
   * validate price difference between scenario_price - current price
   */
    priceDifferenceCalculation(current_price: any, scenario_price: any, decimal_points: any) {
      let price_difference: any = scenario_price - current_price;
      price_difference = parseFloat(price_difference).toFixed(decimal_points);
      return price_difference;
    }

    /**
   * 
   * @param stringNumber 
   * @returns object enables language-sensitive number formatting.
   */
    languageSensitiveFormatting(stringNumber: any){
      return this.parseLocaleNumber(stringNumber).toString();
    }

    /**
   * Parse a localized number to a float.
   * @param {string} stringNumber - the localized number
   * @param {string} locale - [optional] the locale that the number is represented in. Omit this parameter to use the current locale.
   */
    parseLocaleNumber(stringNumber: any) {
      return this.isCurrencyValidation() ? stringNumber : stringNumber.replace(".", ",");
    }
  
    /**Currency Validation*/
    isCurrencyValidation() {
      // --constant.currencyFormat.digitFormat-- Dynamic change has to do from DB configuration ###.##, ###,##
      let currency_code = this.getValuesFromSessionStorage(constant.storage_keys.configuration)[constant.configuration_keys.language_code];
      if (new Intl.NumberFormat(currency_code, { minimumFractionDigits: 2 }).format(constant.currencyFormat.digitFormat).includes('.')) return true;
      else return false;
    }

    /**Currency Validation*/
    // isCurrencyValidation() {
    //   // --constant.currencyFormat.digitFormat-- Dynamic change has to do from DB configuration ###.##, ###,##
    //   let currency_code = localStorage.getItem(constant.common.lang_symbl_front)
    //   if (new Intl.NumberFormat(currency_code, { minimumFractionDigits: 2 }).format(constant.currencyFormat.digitFormat).includes('.')) return true;
    //   else return false;
    // }

    download(response: any, fileType: string, fileName: string) {
      const blob = new Blob([response], {
        type: constant.donwloadFormates[fileType].type
      });
      var downloadURL = window.URL.createObjectURL(response);
      var link = document.createElement('a');
      link.href = downloadURL;
      fileName = fileName.replace(/-\d+\.\w+$/, "");
      link.download = fileName + '_' + this.dateToNiceString(new Date()) + constant.donwloadFormates[fileType].extensions;
      link.click();  
    }

    dateToNiceString(myDate:any) {
      const d = new Date(myDate)
      const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d)
      let mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d)
      const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)
      return da + '-' + mo + '-' + ye;
    }

    sortData(sort: Sort , data: any){
      let direction : SortDirection = sort.direction === 'asc'? "ascending" : "descending"
      let active : string = constant.sortHeaders_price_tier_table[sort.active]
      data = sortArrayOfObjects(data,active,direction)
      return new TableVirtualScrollDataSource<any>(data);
    }

    sortCompetitorData(sort: Sort , data: any){
      let direction : SortDirection = sort.direction === 'asc'? "ascending" : "descending"
      let active : string = constant.sortHeaders_price_tier_table[sort.active]
      data = sortArrayOfObjects(data,sort.active,direction)
      return new TableVirtualScrollDataSource<any>(data);
    }

    maxDateFilter(){
      let timeRestrictionValue = this.getValuesFromSessionStorage(constant.storage_keys.configuration)[constant.configuration_keys.planning_cycle_date_max];
      let restrictedDate :any= moment().add(timeRestrictionValue, 'years');
      return new Date(restrictedDate);
    }

    setMinYears() {
      let timeRestrictionValue = this.getValuesFromSessionStorage(constant.storage_keys.configuration)[constant.configuration_keys.planning_cycle_date_min];
      let restrictedDate :any= moment().subtract(timeRestrictionValue, 'years');
      return new Date(restrictedDate);
    }    
  /**
   * to Describe the date as Today , yesterday or Any date
   * @param inputDate as data
   * @returns day based upon the date
   */
  describeDate(inputDate: any) {
    const today = new Date();
    const yesterday = new Date(new Date().setDate(today.getDate() - 1));
    today.setHours(0, 0, 0, 0);
    yesterday.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);
    if (inputDate.getTime() === today.getTime()) {
      return constant.notification.today;
    } else if (inputDate.getTime() === yesterday.getTime()) {
      return constant.notification.yesterday;
    } else {
      return inputDate.toISOString().split('T')[0];
    }
  }

  /**
   * to get The Time Differnce of Notification in Minutes, Hours
   * @param pastDate as date
   * @returns hours based upon the date
   */
  timeDifference(pastDate: any) {
    const now = new Date();
    const diff = now.getTime() - pastDate.getTime();

    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    if (minutes < 60) {
      return `${minutes} ${constant.notification.min_ago}`;
    } else if (hours < 24) {
      return `${hours} ${constant.notification.hr_ago}`;
    } else {
      return pastDate.toLocaleTimeString([], { hour: constant.notification.two_digits, minute: constant.notification.two_digits, hour12: true });
    }
  }

  /** Saving Navigation Codes in Local Storage */
  setNavigationCodes(data:any){
    this.navigation_codes = data.map((value:any)=>{
      return value.navigation_code
    })
    this.storageService.set(localStorageKeys.navigation_code, this.navigation_codes)
  }

  /** Checking for if Access Available for a Particula Button */
  isAccessAvailable(buttonKey:any){
    return this.features_available.some((feature:any)=>{
      return feature == action_items[buttonKey]
    })
  }

  /** Getting Features Available from Local Storage */
  async getFeatures(){
    this.features_available = await this.storageService.get(localStorageKeys.features_available)
  }

  /** Logout and Clearing the Local Storage */
  async logout(){
    this.storageService.clear(constant.common.local_storage);
    await this.msalService.logoutRedirect();
  }
  
  /**
 * To Change Wheel Speed of A Particular Element of UI
 * @param container as Element of UI
 * @param speedY as Speed of Scroll
 */
  changeWheelSpeed(container: any, speedY: any) {
    var scrollY = 0;
    var handleScrollReset = function () {
      scrollY = container.scrollTop;
    };
    var handleMouseWheel = function (e: any) {
      if (e.deltaY !== 0) {
      e.preventDefault();
      scrollY += speedY * e.deltaY
      if (scrollY < 0) {
        scrollY = 0;
      } else {
        var limitY = container.scrollHeight - container.clientHeight;
        if (scrollY > limitY) {
          scrollY = limitY;
        }
      }
      container.scrollTop = scrollY;
    }
    };
    container.addEventListener('mouseup', handleScrollReset, false);
    container.addEventListener('mousedown', handleScrollReset, false);
    container.addEventListener('wheel', handleMouseWheel, false);
  }

  /**
* To Set Min and Max Date Depending on Effective Date
* @param date as Effective Date
*/
  setEffectiveDateValidation(date: any) {
    let min_date = new Date();
    let max_date = new Date();
    date = new Date(date)
    const month = date.getMonth();
    const year = date.getFullYear();
    min_date = new Date(year, month, 1);
    if (new Date().getTime() > min_date.getTime()) {
      min_date = new Date()
    }
    max_date = new Date(year, month + 1, 0);
    return { max_date: max_date, min_date: min_date };
  }

  getCurrencySymbol(){
    let currency_symbol = this.getValuesFromSessionStorage(constant.storage_keys.configuration)[constant.configuration_keys.currency_symbol];
    return currency_symbol_enum[currency_symbol]
  }

  getPercentageDecimal(){
    return this.getValuesFromSessionStorage(constant.storage_keys.configuration)[constant.configuration_keys.percentage_decimal];
  }

  getRanges(){
    let range_1 = this.getValuesFromSessionStorage(constant.storage_keys.configuration)[constant.configuration_keys.price_range_1]
    let range_2 = this.getValuesFromSessionStorage(constant.storage_keys.configuration)[constant.configuration_keys.price_range_2]
    let range_3 = this.getValuesFromSessionStorage(constant.storage_keys.configuration)[constant.configuration_keys.price_range_3]
    return [range_1,range_2,range_3]
  }
}

